import React, {useContext, useEffect} from "react";
import {Card} from "antd";
import {isMobileOnly} from "react-device-detect";
import DashboardMobile from "../components/dashboard/DashboardMobile";
import DashboardDesktop from "../components/dashboard/DashboardDesktop";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import {useNavigate} from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    const {principal} = useContext(DentobookApplicationContext);

    useEffect(() => {
        if (principal?.user?.role === 'PLATFORM_ADMINISTRATOR') {
            navigate('/users');
        }
    }, []);

    return (
        <AccessControl
            notAccessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR]}>
            <Card
                bordered={false}
                className="dentobook-content"
            >
                {isMobileOnly ? <DashboardMobile/> : <DashboardDesktop/>}
            </Card>
        </AccessControl>
    )
};

export default Home;
